"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _normalizeCoordinate = _interopRequireDefault(require("./normalizeCoordinate"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var EARTH_RADIUS = 6371.01;
var MAX_LAT = Math.PI / 2;
var MIN_LAT = -MAX_LAT;
var MAX_LNG = Math.PI;
var MIN_LNG = -MAX_LNG;
var FULL_CIRCLE_RAD = Math.PI * 2;

var toRadian = function toRadian(x) {
  return x * (Math.PI / 180);
};

var toDegrees = function toDegrees(x) {
  return x * (180 / Math.PI);
};

var _default = function _default(lat, lng, radius) {
  var latR = toRadian(lat);
  var lngR = toRadian(lng);
  var radRadius = radius / EARTH_RADIUS;
  var minLng;
  var maxLng;
  var minLat = latR - radRadius;
  var maxLat = latR + radRadius;

  if (minLat > MIN_LAT && maxLat < MAX_LAT) {
    var deltaLng = Math.asin(Math.sin(radRadius) / Math.cos(latR));
    minLng = lngR - deltaLng;

    if (minLng < MIN_LNG) {
      minLng += FULL_CIRCLE_RAD;
    }

    maxLng = lngR + deltaLng;

    if (maxLng > MAX_LNG) {
      maxLng -= FULL_CIRCLE_RAD;
    }
  } else {
    minLat = Math.max(minLat, MIN_LAT);
    maxLat = Math.min(maxLat, MAX_LAT);
    minLng = MIN_LNG;
    maxLng = MAX_LNG;
  }

  return [maxLat, maxLng, minLat, minLng].map(toDegrees).map(_normalizeCoordinate["default"]);
};

exports["default"] = _default;